export default [
    {
        path: '/storage',
        name: 'Storage',
        meta: {
            requiresAuth: true,
        },
        components: {
            default: () => import('@views/storage/StorageIndex.vue'),
        },
    },
    {
        path: '/storage/create',
        name: 'StorageCreate',
        meta: {
            requiresAuth: true,
        },
        components: {
            default: () => import('@views/storage/StorageCreate.vue'),
        },
    },
    {
        path: '/storage/:id/edit',
        name: 'StorageEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
        },
        components: {
            default: () => import('@views/storage/StorageEdit.vue'),
        },
    },
];
